import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

/**
 * SectionHeader
 * Non-sticky section title with optional left icon and right action link.
 *
 * @param {string} title
 * @param {ReactNode} [icon]
 * @param {string} [actionLabel]
 * @param {() => void} [onAction]
 */
function SectionHeader({ title, icon, actionLabel, onAction }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 1.5,
      }}
    >
      {icon && (
        <Box sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}>
          {icon}
        </Box>
      )}

      <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ flex: 1 }}>
        {title}
      </Typography>

      {actionLabel && onAction && (
        <Button
          size="small"
          endIcon={<ArrowForward sx={{ fontSize: 14 }} />}
          onClick={onAction}
          sx={{
            color: 'primary.main',
            fontWeight: 600,
            fontSize: '0.8125rem',
            minWidth: 0,
            p: 0,
            '&:hover': { background: 'none', opacity: 0.8 },
          }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}

export default SectionHeader;
